import * as storeDetails from '../actionTypes/StoreDetails/storeDetails'
import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'

// on success of getting stores for public user, dispatch the event
function getStoresSuccess (stores) {
  return {
    type: storeDetails.INIT_STORESDETAILS,
    storeDetails: stores
  }
}

// get stores for client
export const initStoresDetails = (callback) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getStores + '?isAdmin=0'
  return (dispatch, getState) => {
    const api = new Api()
    const state = getState()
    if (state.storeDetails.sortParams) {
      url = url + '&Sortby=' + state.storeDetails.sortParams.sortBy + '&sortType=' + state.storeDetails.sortParams.sortType
    } else {
      url = url + '&Sortby=' + 'Brand_Name' + '&sortType=' + 'ASC'
    }
    api.getData(url, data => {
      dispatch(getStoresSuccess(data))
      callback()
    })
  }
}

// on success of getting stores for admin, dispatch the event
function getAdminStoresSuccess (stores) {
  return {
    type: storeDetails.ADMIN_STORESDETAILS,
    adminStoreDetails: stores
  }
}

// get stores for admin
export const adminStoresDetails = (callback) => {
  var params = {}
  var uuid = null
  params = new URLSearchParams(window.location.search)
  uuid = params.get('uuid')
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getStores + '?isAdmin=1'
  return (dispatch, getState) => {
    const api = new Api()
    const state = getState()
    if (state.storeDetails.paginationParams) {
      url = url + '&psize=' + state.storeDetails.paginationParams.pageSize + '&pno=' + state.storeDetails.paginationParams.pageNumber
    } else {
      url = url + '&psize=10&pno=1'
    }
    if (state.storeDetails.sortParams) {
      url = url + '&Sortby=' + (state.storeDetails.sortParams.sortBy ? state.storeDetails.sortParams.sortBy : '') + '&sortType=' + (state.storeDetails.sortParams.sortType ? state.storeDetails.sortParams.sortType : '')
    } else {
      url = url + '&Sortby=' + 'Company_Name' + '&sortType=' + 'ASC'
    }
    if (state.storeDetails.searchParams) {
      url = url + '&criteria=' + (state.storeDetails.searchParams.criteria ? state.storeDetails.searchParams.criteria : '') + '&filter=' + (state.storeDetails.searchParams.filter ? state.storeDetails.searchParams.filter : '')
    }
    if (uuid) {
      url = url + '&uuid=' + uuid
    }

    api.getData(url, data => {
      dispatch(getAdminStoresSuccess(data))
      if (callback !== undefined) {
        callback()
      }
    })
  }
}
// sort Stores
export const sortStores = (sortParams) => {
  return {
    type: storeDetails.SET_SORT_PARAMS,
    sortParams: sortParams
  }
}
// Search stores
export const setStoresSearchParams = (searchParams) => {
  return {
    type: storeDetails.SET_SEARCH_PARAMS_STORES,
    searchParams: searchParams
  }
}

// pagination  for Admin Stores page
export const paginationAdminStores = (paginationParams) => {
  return {
    type: storeDetails.PAGINATION_STORESDETAILS,
    paginationParams: paginationParams
  }
}



// WEBPACK FOOTER //
// ./src/actions/stores.js